import IconCheck from "@/components/icons/check"

export function MessageAddedIcon() {
  return (
    <span className="ml-0.5 whitespace-nowrap">
      <span>&#xfeff;</span>
      <span className="relative top-[-.1em] inline-flex size-3 shrink-0 items-center justify-center rounded-full bg-accent text-accent-foreground">
        <IconCheck size={7} strokeWidth={4} />
      </span>
    </span>
  )
}
